import { ConfigService } from '../../services/config.service';
import { ModalController } from '@ionic/angular';
import { IapService } from '../../services/iap.service';
import { Team } from '../../models/team.model';
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from '@ionic/angular';
import { AppTrial } from '../../models/app-trial.model';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'iap-browser-modal',
  templateUrl: 'iap-browser-modal.html',
  styleUrls: ['./iap-browser-modal.scss'],
})
export class IAPBrowserModal implements OnInit {
  // Data passed in by componentProps
  @Input() teamId: string;
  @Input() message: string;
  @Input() messages: string;
  @Input() title: string;
  @Input() placeholder: string;
  @Input() trial: AppTrial;
  @Input() team: Team;
  @Input() isUserAdmin: boolean;

  blocked = false;

  constructor(
    private analytics: AnalyticsService,
    public modalCtrl: ModalController,
    public toastController: ToastController,
    public iap: IapService,
    public config: ConfigService,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    console.log('IAP - ngOnInit()');
  }

  dismiss() {
    this.analytics.track('qt_iap_dismissed', {
      team_id: this.teamId,
    });
    this.modalCtrl.dismiss();
  }

  openBrowser() {
    window.open('https://apps.apple.com/us/app/quicktext-for-teams/id1528894718', '_blank');
  }
}
